import { VotacoesModel } from "model/api/gestao/votacao-desenvolvimento/votacoes-model";
import { memo, useMemo } from "react";
import { CardRoadmap } from "views/components/cards/card-roadmap";
import { isEmpty } from "lodash";
import { Grid } from "@material-ui/core";
import { CardNaoEncontrado } from "views/components/cards";
import { InformacaoIcon } from "views/components/icons";
import { useSessaoAtual } from "services/app";
import { EnumTipoPessoas } from "model/enums/enum-tipo-pessoas";

export interface VotacoesDesenvolvimentoListDataProps {
    votacoes: VotacoesModel[],
    sistemaSelected: string | null
    handleClickCard: (model: VotacoesModel, desabilitado: boolean) => void
    handleClickLink: (link: string) => void
    handleClickVote: (id: string, tarefaId: string) => Promise<void>
    carregando: boolean
}

// Funções vazias constantes para evitar recriações
const EMPTY_HANDLER = () => { };

export const RoadmapListData = memo(({
    handleClickCard,
    votacoes,
    sistemaSelected,
    handleClickLink,
    handleClickVote,
    carregando
}: VotacoesDesenvolvimentoListDataProps) => {
    const { tipoUsuario } = useSessaoAtual()
    const isTipoRevendedor = tipoUsuario() === EnumTipoPessoas.Revendedor

    const votacoesFiltrados = useMemo(() => {
        return votacoes
            .sort((votacaoA, votacaoB) => votacaoB.votos - votacaoA.votos)
            .filter(votacao => isEmpty(votacao.data_aprovacao) && isEmpty(votacao.data_cancelamento))
            .filter(votacao => {
                // Filtra por sistema selecionado
                const matchesSistema = !sistemaSelected ? false :
                    (votacao.sistema?.toLowerCase().includes(sistemaSelected.toLowerCase()) ?? false);

                // Caso tenha apenas um dos filtros
                return matchesSistema
            })
    }, [sistemaSelected, votacoes])

    // Memoizar a lista de votações renderizadas para evitar recriação desnecessária dos elementos
    const votacoesList = useMemo(() =>
        votacoesFiltrados.map((item, i, arr) => {
            const isAberto = isEmpty(item.data_aprovacao) && isEmpty(item.data_cancelamento)

            return (
                <CardRoadmap
                    key={item.id}
                    model={item}
                    onClick={handleClickCard}
                    onCheck={EMPTY_HANDLER}
                    onClickVote={handleClickVote}
                    selected={false}
                    disabled={!isAberto || !isTipoRevendedor}
                    isDiffRevenda={!isTipoRevendedor}
                    index={i}
                />
            )
        }),
        [votacoesFiltrados, handleClickCard, handleClickVote, isTipoRevendedor]
    );

    return (
        <Grid>
            {!carregando && votacoesFiltrados.length === 0 && (
                <CardNaoEncontrado
                    mensagem="Nenhuma Votação encontrada."
                    icon={<InformacaoIcon tipo="GERAL" />}
                />
            )}
            {(!carregando || votacoesFiltrados.length > 0) && votacoesList}
        </Grid>
    )
})